// Determines the program is complete enough to show /Live and /Public pages

const log = (msg) => process.env.VUE_APP_DEV && console.log(); // eslint-disable-line
import useEventState from "@/composables/useEventState";

export default function showEvents() {
  const {isPreEvent} = useEventState();
  return isPreEvent;
}
